// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dialog__body{word-break:normal}.widget-info .git-icon{cursor:pointer;color:#f05133}", ""]);
// Exports
module.exports = exports;
